import { render, staticRenderFns } from "./input_formatter.vue?vue&type=template&id=f4a1cd78"
import script from "./input_formatter.vue?vue&type=script&lang=js"
export * from "./input_formatter.vue?vue&type=script&lang=js"
import style0 from "./input_formatter.vue?vue&type=style&index=0&id=f4a1cd78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports